import React, { Component } from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant?.js'
import axios from 'axios'
import moment from 'moment'
import { getCurrency } from '../../Constant.js'
import { WaveLoading } from 'react-loadingg'

class EventBookingdetails extends Component {
  state = {
    booking_cancel: 0,
    booking_id: 0,
    model: false,
    booked_by_userId: '',
    openDailog: false,
    open: false,
    limit: 10,
    pageNumber: 0,
    disabled: false,
    keyword: '',
    userdata: [],
    currency: getCurrency('KWT'),
    country: 'KWT',
    booking_data: {},
    sendPaymentModel: false,
    total_Vat: 0,
    complaintModel: false,
    complaintActionModel: false,
  }

  style = {
    tableData: {
      padding: 5,
      paddingLeft: 10,
      border: '1px solid #ddd',
    },
    tableDataUnpaid: {
      background: '#f77',
      color: '#fff',
      fontWeight: 'bold',
    },
    tableDataPaid: {
      background: '#eee',
    },
    cateringCell: {
      paddingLeft: 10,
      paddingTop: 8,
      paddingBottom: 5,
      background: '#999',
    },
  }

  myStyle = {
    fontWeight: 'bold',
  }

  StyleForDetail = {
    marginBottom: '6px',
    letterSpacing: '0.5px',
    display: 'inline-block',
  }

  componentDidMount() {
    if (this.props?.match?.params?.booking_id) {
      this.setState({
        booking_id: this.props.match.params.booking_id,
      })
    }
    this?.getBookingList()
  }

  getBookingList = async () => {
    this.setState({ isloading: true })
    var data = {
      booking_id: this?.props?.match?.params?.booking_id,
    }

    await axios
      .post(Constant?.getAPI() + '/event/booking-details', data, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            booking_data: res?.data?.data,
            currency: getCurrency(res?.data?.data?.country),
            country: res?.data?.data?.country,
          })

          var mappeddate = []
          if (res?.data?.data?.timeSlots) {
            mappeddate = res?.data?.data?.timeSlots?.map((itm) => parseInt(itm?.slot_from?.split(':')?.[0]))
            mappeddate?.sort(function (a, b) {
              return a - b
            })
            var timeStart = []
            var dummy = ':00, '
            for (let i = 0; i < mappeddate?.length; i++) {
              timeStart?.push(mappeddate[i] + dummy)
            }
          }
          var mapdata = []
          if (res?.data?.data?.timeSlots) {
            mapdata = res?.data?.data?.timeSlots?.map((itm) => parseInt(itm?.slot_to?.split(':')[0]))
            mapdata?.sort(function (a, b) {
              return b - a
            })
          }
          this.setState({
            timeData: timeStart,
            timeData1: mapdata?.[0],
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant?.getAuthLogout()
        } else {
          Swal?.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  showDetails = (type) => {
    switch (type) {
      case 'pickup':
        Swal.fire({
          width: '800px',
          title: '<strong>Pickup Details</strong>',
          html: `
            <table>
              <tbody>
                <tr>
                  <th>Address</th>
                  <td style="text-align: left">${this?.state?.booking_data?.pickUp?.pickup_address || '--'}</td></tr>
                <tr>
                  <th>Description</th>
                  <td style="text-align: left">${this?.state?.booking_data?.pickUp?.pickup_desc || '--'}</td></tr>
                <tr>
                  <th>Latitude</th>
                  <td style="text-align: left">${this?.state?.booking_data?.pickUp?.pickup_lat || '--'}</td></tr>
                <tr>
                  <th>Longitude</th>
                  <td style="text-align: left">${this?.state?.booking_data?.pickUp?.pickup_long || '--'}</td></tr>
                <tr>
                  <th>Other Detail</th>
                  <td style="text-align: left">${this?.state?.booking_data?.pickUp?.pickup_other_detail || '--'}</td></tr>
              </tbody>
            </table>
          `,
        })
        break
      case 'payment':
        var content
        if (this.state?.booking_data?.payment_details.length > 0) {
          content = `<div><table style="width:100%">
              <tbody>
                <tr>
                <th></th>
                ${this.state?.booking_data?.payment_details.map((item, index) => `<th style="text-align: left">Payment ${index + 1}</th>`)}
                </tr>
                <tr>
                <th>Payment ID</th>
                ${this.state?.booking_data?.payment_details.map((item) => `<td style="text-align: left">${item.payment_id || '--'}</td>`)}
                </tr>
                <tr>
                <th>Payment Status</th>
                ${this.state?.booking_data?.payment_details.map((item) => '<td style="text-align: left">' + (item.payment_status || '--') + '</td>')}
                </tr>
                <tr>
                <th>Payment Method</th>
                ${this.state?.booking_data?.payment_details.map((item) => '<td style="text-align: left">' + (item?.payment_method?.PaymentMethod_en || '--') + '</td>')}
                </tr>
                <tr>
                  <th>Payment Amount</th>
                  ${this.state?.booking_data?.payment_details
                    .map(
                      (item) => `
                    <td style="text-align: left; ${item.payment_amount < 0 ? 'background-color: red; color: white;' : ''}">
                      ${item.payment_currency || this.state.currency} ${item.payment_amount}
                    </td>
                  `
                    )
                    .join('')}
                </tr>
                <tr>
                <th>Transaction ID</th>
                ${this.state?.booking_data?.payment_details.map((item) => '<td style="text-align: left">' + (item.txn_id || '--') + '</td>')}
                </tr>
                <tr>
                <th>Invoice Reference ID</th>
                ${this.state?.booking_data?.payment_details.map((item) => '<td style="text-align: left">' + (item.payment_info.InvoiceReference || '--') + '</td>')}
                </tr>
                <tr>
                <th>Payment Created at</th>
                ${this.state?.booking_data?.payment_details.map((item) => '<td style="text-align: left">' + (item.createdAt ? moment(item.createdAt).format('YYYY-MM-DD HH:mm') : '--') + '</td>')}
                </tr>
              </tbody>
              </table>
              </div>
            `

          Swal.fire({
            width: '1000px',
            title: '<strong>Payment Details</strong>',
            html: content,
          })
        } else {
          Swal.fire({
            title: '<strong>Payment Details Not Found</strong>',
            icon: 'error',
            type: 'error',
          })
        }
        break
      default:
        break
    }
  }

  handleChange = (event) => {
    event.preventDefault()
    this.setState({ [event.target.name]: event.target.value })
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        {this.state.isLoading == true && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.5)',
              zIndex: 10000,
            }}
            onClick={(e) => {
              e.preventDefault()
            }}
          >
            <WaveLoading />
          </div>
        )}
        <div className="main-body">
          <div className="page-wrapper">
            <div
              className="page-header"
              id="store-order-header"
            >
              <div className="row align-items-end">
                <div className="col-3">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Event Booking Details</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="page-body"
              id="store-order-details"
            >
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      {this.state?.booking_data ? (
                        <>
                          <div
                            className="row"
                            style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                          >
                            <div
                              className="col-md-6 col-sm-12"
                              style={{ borderRight: '1px solid #ddd' }}
                            >
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Booking Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Booking ID</div>
                                  <div>Booking Status</div>
                                  <div>Booking Date</div>
                                  <div>Booking Time Slots</div>
                                  <div>Ticket Booked</div>
                                  <div>Issue Date</div>
                                  <div>Commented At</div>
                                  <div>Comments</div>
                                </div>
                                <div className="col-5">
                                  <div>
                                    {this?.state?.booking_data?.order_number || '--'}{' '}
                                    {this.state.booking_data?.from_flash_offer == true && (
                                      <img
                                        src={'./assets/images/ic_flash_icon.png'}
                                        alt="img"
                                        onError={(event) => {
                                          event.currentTarget.src = './assets/images/ic_flash_icon.png'
                                        }}
                                        style={{ height: 20 }}
                                      />
                                    )}
                                  </div>
                                  <div>{this?.state?.booking_data?.booking_status || '--'}</div>
                                  <div>{this?.state?.booking_data?.bookingDate || '--'}</div>
                                  <div>
                                    {this?.state?.booking_data?.eventBookingDetails?.eventSlotDetails?.start_time &&
                                    this?.state?.booking_data?.eventBookingDetails?.eventSlotDetails?.end_time
                                      ? `${this?.state?.booking_data?.eventBookingDetails?.eventSlotDetails?.start_time}  -  ${this?.state?.booking_data?.eventBookingDetails?.eventSlotDetails?.end_time}`
                                      : '--'}
                                  </div>
                                  <div>
                                    {this?.state?.booking_data?.ticket_booked}(Adult),{' '}
                                    {this?.state?.booking_data?.child_ticket_booked}(Child)
                                  </div>
                                  <div>
                                    {this?.state?.booking_data?.orderPlacedDate
                                      ? moment(this?.state?.booking_data?.orderPlacedDate).format('YYYY-MM-DD hh:mm A')
                                      : '--'}
                                  </div>
                                  <div>{this?.state?.booking_data?.comment_at || '--'}</div>
                                  <div>{this?.state?.booking_data?.comments || '--'}</div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>User Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Name</div>
                                </div>
                                <div className="col-5">
                                  <div>
                                    {this?.state?.booking_data?.clientDetails?.first_name || '--'}{' '}
                                    {this?.state?.booking_data?.clientDetails?.last_name}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ padding: 10, borderBottom: '1px solid #ddd', marginBottom: 10 }}
                          >
                            <div
                              className="col-md-6 col-sm-12"
                              style={{ borderRight: '1px solid #ddd' }}
                            >
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Event Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Name</div>
                                  <div>
                                    Pickup position
                                    <img
                                      className="img-fluid m-l-5"
                                      src="./assets/images/info.png"
                                      alt="ico"
                                      style={{ width: 13 }}
                                      onClick={() => this.showDetails('pickup')}
                                    />
                                  </div>
                                  <div>Description</div>
                                </div>
                                <div className="col-5">
                                  <div>{this?.state?.booking_data?.eventBookingDetails?.event_name || '--'}</div>
                                  <div>{this?.state?.booking_data?.pickUp?.pickup_address || '--'}</div>
                                  <div>{this?.state?.booking_data?.eventBookingDetails?.event_desc || '--'}</div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Company Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Company Name</div>
                                  {/* <div>Company Email</div> */}
                                  {/* <div>Company Phone</div> */}
                                </div>
                                <div className="col-5">
                                  <div>{this?.state?.booking_data?.company_details?.companyName || '--'}</div>
                                  {/* <div>{this.state?.booking_data?.company_details?.companyEmail || '--'}</div> */}
                                  {/* <div>{this?.state?.booking_data?.company_details?.companyPhone || 'N/A'}</div> */}
                                </div>
                              </div>
                            </div>
                          </div>

                          {this.state?.booking_data?.additional_items_list?.length > 0 && (
                            <div className="row">
                              <div
                                className="col-2"
                                style={{ fontWeight: 'bold' }}
                              >
                                Catering
                              </div>
                              <div className="col-10">
                                <div className="row">
                                  <div className="col-sm-12">
                                    <div className="table-responsive">
                                      <table className="table">
                                        <thead>
                                          <tr
                                            className="thead-inverse"
                                            style={{ height: 40 }}
                                          >
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Item Name
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Shop Name
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Special Request
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Payment status
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Quantity
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Delivery charge
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Unit Price
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Add Ons Price
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Total</th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Delivery
                                              <br /> Date & Time
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state?.booking_data?.additional_items_list?.length > 0 &&
                                            this.state?.booking_data?.additional_items_list
                                              .filter((item) => item?.store_item?.store?.shop_type === 'CATERING')
                                              .map((item) => {
                                                return (
                                                  <>
                                                    <tr
                                                      key={item.id}
                                                      style={
                                                        item?.payment_status
                                                          ? this.style.tableDataPaid
                                                          : this.style.tableDataUnpaid
                                                      }
                                                    >
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.item_name || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.store?.shop_name || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>{item?.notes || '--'}</td>
                                                      <td style={this.style.tableData}>
                                                        {item?.payment_status === true ? (
                                                          <span className="badge badge-success">Success</span>
                                                        ) : (
                                                          <span className="badge badge-danger">Pending</span>
                                                        )}
                                                      </td>
                                                      <td style={this.style.tableData}>{item.item_qty || '--'}</td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + (item.delivery_charge || '0')}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + item?.amount}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + item?.addons_amount}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency +
                                                          ' ' +
                                                          (item?.amount + item?.addons_amount)}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {`${item.delivery_date} -- ${item.delivery_time}`}
                                                      </td>
                                                    </tr>
                                                    {item?.catering_items?.length > 0 && (
                                                      <tr style={{ background: '#eee', border: '1px solid #ddd' }}>
                                                        <td colSpan={10}>
                                                          <table
                                                            key={item.id}
                                                            className="table"
                                                          >
                                                            <tbody>
                                                              <tr
                                                                className="thead-inverse"
                                                                style={{ height: 20, background: '#555' }}
                                                              >
                                                                <th style={this.style.cateringCell}>Item Name</th>
                                                                <th style={this.style.cateringCell}>Quantity</th>
                                                                <th style={this.style.cateringCell}>Unit Price</th>
                                                                <th style={this.style.cateringCell}>Total Price</th>
                                                              </tr>
                                                              {item?.catering_items.map((ele) => (
                                                                <tr key={ele.id}>
                                                                  <td
                                                                    style={{
                                                                      ...this.style.tableData,
                                                                      background: '#eec',
                                                                    }}
                                                                  >
                                                                    {ele?.store_catering_item?.name || '--'}
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      ...this.style.tableData,
                                                                      background: '#eec',
                                                                    }}
                                                                  >
                                                                    {ele.item_qty || '--'}
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      ...this.style.tableData,
                                                                      background: '#eec',
                                                                    }}
                                                                  >
                                                                    {this.state?.currency +
                                                                      ' ' +
                                                                      (ele.is_addon ? ele?.amount : 0)}
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      ...this.style.tableData,
                                                                      background: '#eec',
                                                                    }}
                                                                  >
                                                                    {this.state?.currency +
                                                                      ' ' +
                                                                      (ele.is_addon ? ele?.amount * ele.item_qty : 0)}
                                                                  </td>
                                                                </tr>
                                                              ))}
                                                            </tbody>
                                                          </table>
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </>
                                                )
                                              })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        'No details Found'
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EventBookingdetails
